import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

const FloatCard = ({ children, shadowClassName, strokeClassName }) => (
  <svg
    className={shadowClassName}
    fill="none"
    height="388"
    width="320"
    xmlns="https://www.w3.org/2000/svg"
  >
    <g filter="url(#a)">
      <path
        className={twJoin(
          strokeClassName,
          'fill-neutral-high-100 dark:fill-neutral-low-500'
        )}
        clipRule="evenodd"
        d="M10 18a8 8 0 0 1 8-8h285.001A7 7 0 0 1 310 16.999c0 3.6-2.757 6.55-6.245 7.445-17.971 4.605-31.255 20.91-31.255 40.318 0 19.09 12.854 35.18 30.379 40.083 3.963 1.109 7.121 4.472 7.121 8.587V370a8 8 0 0 1-8 8H103.702a2.036 2.036 0 0 1-2.036-2.036c0-21.861-17.722-39.583-39.583-39.583-21.861 0-39.583 17.722-39.583 39.583A2.036 2.036 0 0 1 20.464 378H16.25a6.25 6.25 0 0 1-6.25-6.25V18Z"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="388"
        id="a"
        width="320"
        x="0"
        y="0"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in2="BackgroundImageFix" />
        <feBlend in="SourceGraphic" result="shape" />
      </filter>
    </defs>
    <foreignObject height="368" width="300" x="3%" y="3%">
      <div className="flex size-full flex-col items-center justify-center p-6">
        {children}
      </div>
    </foreignObject>
  </svg>
);

FloatCard.propTypes = {
  children: PropTypes.node.isRequired,
  shadowClassName: PropTypes.string.isRequired,
  strokeClassName: PropTypes.string.isRequired,
};

export default FloatCard;
